module.exports = __webpack_public_path__ + "img/placeholder-person.e443de96.jpg";